import { createSingleEntityStore, pipeState } from '@recruitee/ngrx';

import {
  EntityStoreKey,
  JobTemplateTranslations,
  JobTemplateTranslationsUpdateRequest,
} from './job-templates-translations.types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<JobTemplateTranslations>()(EntityStoreKey.JobTemplateTranslations, {
    customActions: adapter => ({
      fetchTranslations: (
        state,
        payload: {
          jobTemplateId: number;
          targetLangCode: string;
        },
      ) => adapter.markAsPending(state),

      fetchTranslationsSuccess: (state, payload: JobTemplateTranslations) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      fetchTranslationsFailed: (state, err: string) => adapter.setError(state, Error(err)),

      updateTranslations: (
        state,
        payload: {
          jobTemplateId: number;
          jobTemplate: JobTemplateTranslationsUpdateRequest;
        },
      ) => adapter.markAsPending(state),
      updateTranslationsSuccess: (state, payload: JobTemplateTranslations) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      updateTranslationsFailed: (state, err: string) => adapter.setError(state, Error(err)),
    }),
  });

export {
  actions as JobTemplateTranslationsActions,
  selectors as JobTemplateTranslationsSelectors,
  reducer as JobTemplateTranslationsReducer,
  namespace as JobTemplateTranslationsNamespace,
};
